import { useMemo } from 'react';
import type { CreateDestination } from '../../components/features/create/destination/createDestination';
import type { CreateRequest } from '../../stores/createModalStore';
import { useOpenCreate } from './useOpenCreate';

export interface ModalCreateOpeners {
  /** Step 1 of the modal, for this destination. */
  readonly openChoose: () => void;
  readonly onOpenCollection: () => void;
  readonly onOpenEquipment: () => void;
  readonly onOpenImport: () => void;
  readonly onOpenProtocolCreate: () => void;
  readonly onOpenSpreadsheet: () => void;
  readonly onOpenLink: () => void;
}

/**
 * Openers for the one Create modal, aimed at `destination` (absent: what is
 * in view): step 1, or straight to one type.
 */
export function useModalCreateOpeners(
  destination: CreateDestination | undefined,
  surface: string,
  options: Pick<CreateRequest, 'onCollectionCreated'> = {},
): ModalCreateOpeners {
  const open = useOpenCreate();
  const { onCollectionCreated } = options;
  return useMemo(() => {
    const at = (type?: string) => () => open({ surface, destination, type, onCollectionCreated });
    return {
      openChoose: at(),
      onOpenCollection: at('collection'),
      onOpenEquipment: at('equipment'),
      onOpenImport: at('import'),
      onOpenProtocolCreate: at('protocol'),
      onOpenSpreadsheet: at('spreadsheet'),
      onOpenLink: at('link'),
    };
  }, [open, destination, surface, onCollectionCreated]);
}
